import { render, staticRenderFns } from "./roomTypeList.vue?vue&type=template&id=424db295&scoped=true"
import script from "./roomTypeList.vue?vue&type=script&lang=js"
export * from "./roomTypeList.vue?vue&type=script&lang=js"
import style0 from "./roomTypeList.vue?vue&type=style&index=0&id=424db295&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424db295",
  null
  
)

export default component.exports